import '@/user/common';
import React from 'react';
import ReactDom from 'react-dom';
import Concept from '@/shared/components/concept/';
import { getConceptTop, getConceptStaff, getConceptPortfolio } from './api';

// ReactのConceptを呼び出す
const concept = document.getElementById('concept');
let hallId = parseInt(concept.dataset.hall_id);

if (concept) {
    ReactDom.render(
        <Concept
            hallId={hallId}
            getConceptTop={getConceptTop}
            getConceptStaff={getConceptStaff}
            getConceptPortfolio={getConceptPortfolio}
        />,
        concept,
    );
}
